import bulmaCollapsible from '@creativebulma/bulma-collapsible'

jQuery(function ($) {
  if ($('#search-form-header .button').length !== 0) {
    $('.button, button').wrap('<div class="button-wrap"></div>')
  }

  // Menu drawer canvas
  $('#right').offcanvas({
    modifiers: 'right,overlay',
    triggerButton: '.js-offcanvas-trigger',
  })

  $('#left').offcanvas({
    modifiers: 'left, overlay', // default options
    triggerButton: '.js-offcanvas-trigger', // btn to open offcanvas
  })

  $('.js-offcanvas-trigger').on('click', function () {
    $('#drawer-menu').show()
  })

  $('#FilterCanvas').offcanvas({
    modifiers: 'left, overlay', // default options
    triggerButton: '#filterTrigger', // btn to open offcanvas
    onOpen: function () {
      $('.sidebar-canvas').show()
    },
  })

  $(document).on('close.offcanvas', function (e) {
    $('.sidebar-canvas').hide()
    $('#drawer-menu').hide()
  })
})

// Disable faq JS for IE11

function GetIEVersion() {
  var sAgent = window.navigator.userAgent
  var Idx = sAgent.indexOf('MSIE')

  // If IE, return version number.
  if (Idx > 0) return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)))
  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11
  else return 0 //It is not IE
}

if (GetIEVersion() == 0) {
  jQuery(function ($) {
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible')
  })
}
